import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class FileItem extends PureComponent {
  render() {
    const { connectDragSource, isDragging, label } = this.props;
    return connectDragSource(
      <div className="gs-import__value gs-import__entity"
           style={{
             opacity: isDragging ? 0.5 : 1,
             cursor: 'move',
           }}
      >
        <div className="gs-import__value__item" >
            <span className="gs-text _sm">{ label }</span>
        </div>
      </div>
    );
  }
}

FileItem.propTypes = {
  unsetField: PropTypes.func,
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

export default FileItem;
